import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGallery = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 46 38",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Galleri",
		transform: "translate(-434 -1321)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "panorama_FILL1_wght500_GRAD0_opsz48",
				d: "M75.867,267.45a1.875,1.875,0,0,1-1.845-1.846v-13.97a1.878,1.878,0,0,1,1.845-1.852h18.3a1.882,1.882,0,0,1,1.852,1.852V265.6a1.878,1.878,0,0,1-1.852,1.846Zm2.459-4.5H91.738l-4.092-5.546L84.1,262.121l-2.492-3.495Z",
				transform: "translate(359.978 1071.219)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_653",
				"data-name": "Rectangle 653",
				width: 22,
				height: 18,
				rx: 2,
				transform: "translate(458 1321)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_654",
				"data-name": "Rectangle 654",
				width: 22,
				height: 18,
				rx: 2,
				transform: "translate(458 1341)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_655",
				"data-name": "Rectangle 655",
				width: 22,
				height: 18,
				rx: 2,
				transform: "translate(434 1341)"
			})
		]
	})
});
export default SvgGallery;
